import { VueSlideToggle } from "vue-slide-toggle";
import { isClickableInSidebarMenu, isProcessableItem, routeForMenuItem } from "@/helpers";

export default {
  name: "burger-nav",
  components: {
    VueSlideToggle,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      open: false,
      openSubMenu: false,
    };
  },
  methods: {
    isClickableInSidebarMenu: isClickableInSidebarMenu,
    isProcessableItem: isProcessableItem,
    /**
     * @param {NavigationItem} navItem
     * @param {NavigationItem|null} parentNavItem
     * @return {Object}
     */
    routeForMenuItem(navItem, parentNavItem = null) {
      if (navItem.slug === "cosmo-base") {
        return this.$localize({ name: "cosmobase" });
      }
      if (navItem.slug === "before-after") {
        return this.$localize({ name: "before-after" });
      }
      if (navItem.slug === "forum") {
        return this.$localize({ name: "ProAge" });
      }
      if (navItem.slug === "promotions") {
        return this.$localize({ name: "promotions" });
      }
      if (navItem.slug === "outlet") {
        return this.$localize({ name: "products", query: { categories: 'outlet' } });
      }
      return this.$localize(routeForMenuItem(navItem, parentNavItem));
    },
  },
};
